<template>

  <v-card flat tile class="fid-card">

    <Player v-if="usePlayer" big :reason="itemReason" :vimeo-pictures="VimeoVideoPicturesInfo" :master="master">
    </Player>

  </v-card>
</template>
<script>

import { isBoss } from '@/js/store'
import Player from '@/components/Player'
import { SearchUtils } from '@/js'
import { VimeoVideoPicturesInfo, ProviderAuth } from '@/gql'
import { mapState, mapMutations, mapGetters } from 'vuex'
import { vxMaps } from '@/js/vxstore'
export default {
  props: {
    itemReason: Object,
    usePlayer: Boolean,
    rowType: String,
    allPrizes: Array,
    storyHeader: String,
    dirty: Boolean,
    master: Object
  },
  components: {
    Player
  },

  data: () => ({
    VimeoVideoPicturesInfo: null,
    ProviderAuth: null,
    activeSection: null
  }),
  methods: {
    // section is showable if none are showable, or its selected
    presentable(propName) {
      return !this.bigActiveSection || this.bigActiveSection === propName
    },
    ...mapMutations(vxMaps.mutations)
  },
  computed: {
    filmName() {
      return this.isFilm && this.itemReason && this.itemReason.match
    },
    hostType() {
      return this.master && this.master.hostType
    },
    hostID() {
      return this.master && this.master.hostID
    },
    permittedEditor() {
      // this is temporary till we figure out how to validate ownership of films
      return isBoss(this.ProviderAuth && this.ProviderAuth.userID)
    },
    // whether this page is editable, and for what reason
    editable() {
      // for testing turn on editing for bosses anyway
      return Boolean(this.editing || (this.permittedEditor ? 'fid' : ''))
    },
    breakpoint() {
      return this.$vuetify.breakpoint
    },
    userID() {
      return this.ProviderAuth && this.ProviderAuth.userID
    },
    isFilm() {
      return this.rowType === 'film' || this.rowType === 'vimeofilm'
    },
    story() {
      const story = SearchUtils.getStoryFromReason({ reason: this.itemReason, rowType: this.rowType, allPrizes: this.allPrizes })
      return story
    },
    ...mapState(vxMaps.state),
    ...mapGetters(vxMaps.getters)
  },
  apollo: {
    ProviderAuth: {
      query: ProviderAuth
    },
    VimeoVideoPicturesInfo: {
      skip() {
        const skip = this.hostType !== 'vimeo' || !this.hostID || !this.userID // || this.editing !== 'vimeofilm' || 
        return skip
      },
      query() {
        return VimeoVideoPicturesInfo
      },
      variables() {
        return {
          id: this.userID,
          videoID: this.hostID,
          limit: 100
        }
      }
    }
  }

}
</script>
